import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Boothfee } from './boothfee.model';
import { BoothfeePopupService } from './boothfee-popup.service';
import { BoothfeeService } from './boothfee.service';
import { Marketday, MarketdayService } from '../marketday';

@Component({
    selector: 'jhi-boothfee-dialog',
    templateUrl: './boothfee-dialog.component.html'
})
export class BoothfeeDialogComponent implements OnInit {

    boothfee: Boothfee;
    authorities: any[];
    isSaving: boolean;

    marketdays: Marketday[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private boothfeeService: BoothfeeService,
        private marketdayService: MarketdayService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['boothfee']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketdayService.query().subscribe(
            (res: Response) => { this.marketdays = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.boothfee.id !== undefined) {
            this.boothfeeService.update(this.boothfee)
                .subscribe((res: Boothfee) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.boothfeeService.create(this.boothfee)
                .subscribe((res: Boothfee) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: Boothfee) {
        this.eventManager.broadcast({ name: 'boothfeeListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackMarketdayById(index: number, item: Marketday) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-boothfee-popup',
    template: ''
})
export class BoothfeePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private boothfeePopupService: BoothfeePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.boothfeePopupService
                    .open(BoothfeeDialogComponent, params['id']);
            } else {
                this.modalRef = this.boothfeePopupService
                    .open(BoothfeeDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/boothfee/boothfee-dialog.component.ts